(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[764],{

/***/ 977:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/san-pham/bat-dong-san",
      function () {
        return __webpack_require__(7093);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ro": function() { return /* binding */ useFetchProject; },
  "JJ": function() { return /* binding */ useFetchProjectList; }
});

// UNUSED EXPORTS: fetchProject, fetchProjectList, fetchProjects, useFetchProjects

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 6 modules
var lib_useQuery = __webpack_require__(7848);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(5945);
// EXTERNAL MODULE: ./apis/fetch.js + 1 modules
var fetch = __webpack_require__(9900);
// EXTERNAL MODULE: ./utils/lodash.js
var lodash = __webpack_require__(9926);
;// CONCATENATED MODULE: ./apis/queryKeys/projectKeys.js


// const sort = {
// 	date_created: -1,
// };
var projectKeys_projectKeys = {
    all: [
        {
            scope: "project",
            limit: 100
        }
    ],
    count: function(options) {
        return [
            (0,_object_spread/* default */.Z)({
                scope: "project",
                type: "count"
            }, (0,lodash/* flattenObj */.nO)(options || {})), 
        ];
    },
    list: function(list) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return [
            {
                scope: "project",
                type: "list",
                list: list,
                options: options
            }, 
        ];
    },
    detail: function(ma_trang) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return [
            {
                scope: "project",
                type: "detail",
                ma_trang: ma_trang,
                options: options
            }, 
        ];
    }
};
/* harmony default export */ var queryKeys_projectKeys = (projectKeys_projectKeys);

;// CONCATENATED MODULE: ./apis/queryFunctions/projects.js







var fetchProject = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(idProject) {
        var options, _tmp, data, _tmp1;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : _tmp;
                    _tmp1 = {};
                    return [
                        4,
                        (0,fetch/* asyncGetItem */.p9)((_tmp1.collection_name = "news", _tmp1.options = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            shared: true
                        }, options), {
                            condition: (0,_object_spread/* default */.Z)({
                                ma_trang: idProject,
                                status: true,
                                shared: true,
                                ngon_ngu: "vi"
                            }, (options === null || options === void 0 ? void 0 : options.condition) || {})
                        }), _tmp1))
                    ];
                case 1:
                    data = _state.sent();
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchProject(idProject) {
        return _ref.apply(this, arguments);
    };
}();
var fetchProjects = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(list) {
        var options, _tmp, _tmp1;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : _tmp;
                    _tmp1 = {};
                    return [
                        4,
                        (0,fetch/* asyncGetList */.NE)((_tmp1.collection_name = "news", _tmp1.options = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                            condition: (0,_object_spread/* default */.Z)({
                                // ma_loai_tin_tuc: "thong-tin-trang",
                                // ma_trang: { $in: [...list] },
                                status: true,
                                shared: true,
                                ngon_ngu: "vi"
                            }, (options === null || options === void 0 ? void 0 : options.condition) || {})
                        }), _tmp1))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function fetchProjects(list) {
        return _ref.apply(this, arguments);
    };
}();
var fetchProjectList = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var options, _tmp, _tmp1;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    options = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : _tmp;
                    _tmp1 = {};
                    return [
                        4,
                        (0,fetch/* asyncGetList */.NE)((_tmp1.collection_name = "news", _tmp1.options = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                            condition: (0,_object_spread/* default */.Z)({
                                // ma_loai_tin_tuc: "thong-tin-trang",
                                // ma_trang: { $in: [...list] },
                                status: true,
                                shared: true,
                                ngon_ngu: "vi"
                            }, (options === null || options === void 0 ? void 0 : options.condition) || {})
                        }), _tmp1))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function fetchProjectList() {
        return _ref.apply(this, arguments);
    };
}();
var useFetchProject = function(idProject) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return (0,lib_useQuery/* useQuery */.a)(queryKeys_projectKeys.detail(idProject, options), function() {
        return fetchProject(idProject, options);
    }, {
        staleTime: 3600000,
        enabled: !!idProject
    });
};
var useFetchProjects = function(list) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var queryClient = useQueryClient();
    return useQuery(projectKeys.list(list, options), function() {
        return fetchProjects(list, options);
    }, {
        staleTime: 3600000,
        enabled: !list,
        onSuccess: function(projects) {
            projects.map(function(project) {
                queryClient.setQueriesData(projectKeys.detail(project.ma_trang, options), project);
            });
        }
    });
};
var useFetchProjectList = function(options) {
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    return (0,lib_useQuery/* useQuery */.a)(queryKeys_projectKeys.list(options), function() {
        return fetchProjectList(options);
    }, {
        staleTime: 3600000,
        enabled: !!options,
        onSuccess: function(projects) {
            projects.map(function(project) {
                queryClient.setQueriesData(queryKeys_projectKeys.detail(project.ma_trang, options), project);
            });
        }
    });
};


/***/ }),

/***/ 9235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BtnShowMore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7841);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5117);
/* harmony import */ var _react_icons_all_files_io_IoMdArrowRoundForward__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3793);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);







function BtnShowMore(param) {
    var children = param.children, href = param.href;
    // const target = href?.indexOf("http") > -1 ? "_blank" : "_self";
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    var label = {
        vi: "Xem th\xeam",
        en: "Show more"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, {
            component: "a",
            variant: "outline",
            mt: "sm",
            sx: function(theme) {
                return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    minHeight: 46,
                    minWidth: 154,
                    borderRadius: 13,
                    borderColor: "".concat(theme.colors.neutral[3]),
                    borderWidth: 1,
                    borderStyle: "solid",
                    color: theme.colors.neutral[3],
                    fontSize: 14,
                    fontWeight: 500,
                    transition: "all 700ms ease",
                    "&:hover": {
                        backgroundColor: theme.fn.darken(theme.colors.accent[2], 0.05),
                        color: theme.white,
                        borderColor: "transparent",
                        borderWidth: 1
                    }
                }, "@media (max-width: ".concat(theme.breakpoints.sm, "px)"), {
                    backgroundColor: theme.fn.darken(theme.colors.accent[2], 0.05),
                    color: theme.white,
                    borderColor: "transparent",
                    borderWidth: 1
                });
            },
            styles: {
                rightIcon: {
                    marginLeft: 5
                }
            },
            rightIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_io_IoMdArrowRoundForward__WEBPACK_IMPORTED_MODULE_6__/* .IoMdArrowRoundForward */ .n, {
                size: 26
            }),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                    children: label === null || label === void 0 ? void 0 : label[locale]
                }),
                children
            ]
        })
    });
};


/***/ }),

/***/ 1623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6646);
/* harmony import */ var _utils_lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9926);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2962);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);






function DefaultSEO(param) {
    var seo = param.seo;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().locale;
    if (!seo || (0,_utils_lodash__WEBPACK_IMPORTED_MODULE_4__/* .isEmpty */ .xb)(seo)) return null;
    var images = [];
    if (seo.picture1) {
        images.push({
            url: (0,_utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                src: seo.picture1,
                size: "xl"
            }),
            width: 1200,
            height: 630,
            alt: "Đầu tư c\xf9ng ZenOne",
            type: "image/*"
        });
    }
    if (seo.picture2) {
        images.push({
            url: (0,_utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                src: seo.picture2,
                size: "xl"
            }),
            width: 1200,
            height: 1200,
            alt: "ZenOne logo",
            type: "image/*"
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_2__/* .NextSeo */ .PB, {
        title: seo === null || seo === void 0 ? void 0 : seo.title,
        description: seo === null || seo === void 0 ? void 0 : seo.description,
        openGraph: {
            url: (seo === null || seo === void 0 ? void 0 : seo.url) ? "".concat("https://zenone.com.vn").concat(seo.url) : "https://zenone.com.vn",
            // url: "https://zenone.com.vn",
            title: seo.title,
            description: seo.description,
            images: images,
            locale: locale,
            type: seo.type || "website",
            siteName: "ZenOne",
            article: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (seo === null || seo === void 0 ? void 0 : seo.article) || {})
        },
        twitter: {
            cardType: "summary_large_image"
        }
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (DefaultSEO);


/***/ }),

/***/ 5603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_FormSupport; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./common/MainLayout/Footer/Components/Form.js + 4 modules
var Form = __webpack_require__(153);
;// CONCATENATED MODULE: ./public/images/background_bdsform.png
/* harmony default export */ var background_bdsform = ({"src":"/_next/static/media/background_bdsform.853d8748.png","height":1248,"width":3726,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAABlBMVEUAFSkAFCjLRj4mAAAAAXRSTlPuB1QXGQAAAAlwSFlzAAAhOAAAITgBRZYxYAAAABNJREFUCJljYIQABgYogxHGYAAAAUsAF5PZ0ykAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./public/images/background_form.png
/* harmony default export */ var background_form = ({"src":"/_next/static/media/background_form.3a5dce3b.png","height":373,"width":1057,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAFVBMVEUAEycVMUIjQlE2W2dJc34sTlsJIDPQWZfQAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGElEQVQImWNgAAFGJiYGZkYog4UZLMQIAAEvABi12XrhAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":3});
// EXTERNAL MODULE: ./utils/appendImageUrlFromAPI.js + 1 modules
var appendImageUrlFromAPI = __webpack_require__(6646);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(6817);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Grid/Grid.js + 4 modules
var Grid = __webpack_require__(50);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Center/Center.js
var Center = __webpack_require__(9094);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-media-query/use-media-query.js
var use_media_query = __webpack_require__(4065);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./public/images/ZengroupTower.jpg
/* harmony default export */ var ZengroupTower = ({"src":"/_next/static/media/ZengroupTower.48f7c5e1.jpg","height":900,"width":1600,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAfEAACAQIHAAAAAAAAAAAAAAABAgADIQQFERITFZH/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAv/EABcRAQEBAQAAAAAAAAAAAAAAAAIAEQH/2gAMAwEAAhEDEQA/AKFbPR1LK+DV1ZgNvIQLNf3WIiONZQgdv//Z","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./common/components/FormSupport.js












var useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    var _obj, _obj1;
    return {
        form: (_obj = {}, (0,_define_property/* default */.Z)(_obj, "@media (max-width: ".concat(theme.breakpoints.sm, "px)"), {
            maxWidth: "350px"
        }), (0,_define_property/* default */.Z)(_obj, "maxWidth", 470), _obj),
        formBds: (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, "@media (max-width: ".concat(theme.breakpoints.sm, "px)"), {
            maxWidth: "324px"
        }), (0,_define_property/* default */.Z)(_obj1, "maxWidth", 414), _obj1)
    };
});
function FormSupport(param) {
    var _id = param.id, id = _id === void 0 ? "" : _id, _slug = param.slug, slug = _slug === void 0 ? "" : _slug, _bds = param.bds, bds = _bds === void 0 ? false : _bds, list = param.list, position = param.position;
    var classes = useStyles().classes;
    var locale = (0,router.useRouter)().locale;
    var isMobile = (0,use_media_query/* useMediaQuery */.a)("(max-width: 768px)");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        sx: function(theme) {
            var _obj;
            return _obj = {
                position: "relative",
                borderRadius: isMobile ? 40 : 63,
                overflow: "hidden",
                height: 416
            }, (0,_define_property/* default */.Z)(_obj, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
                height: 580
            }), (0,_define_property/* default */.Z)(_obj, "backgroundColor", bds ? "#00152A" : "none"), _obj;
        },
        children: [
            !bds && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: background_form,
                alt: "bg",
                layout: "fill",
                objectFit: "cover",
                objectPosition: "left"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                sx: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0
                },
                children: bds ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid */.r, {
                    sx: function(theme) {
                        return (0,_define_property/* default */.Z)({
                            height: "100%",
                            padding: "10px 44px 0px"
                        }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
                            padding: "20px 27px "
                        });
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                            md: 6,
                            sx: function(theme) {
                                return (0,_define_property/* default */.Z)({
                                    padding: 8
                                }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
                                    padding: 0
                                });
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                                sx: {
                                    height: "100%"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                    sx: function(theme) {
                                        return {
                                            position: "relative",
                                            height: "100%",
                                            width: "100%",
                                            maxHeight: 350,
                                            maxWidth: 550,
                                            minHeight: 180,
                                            margin: "auto",
                                            alignItems: "center",
                                            borderRadius: isMobile ? 14 : 38,
                                            overflow: "hidden",
                                            aspectRatio: 2
                                        };
                                    },
                                    children: list && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        alt: "product-detail-image",
                                        src: ZengroupTower,
                                        layout: "fill",
                                        objectFit: "cover",
                                        width: 470,
                                        height: 296
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                            md: 5.7,
                            sx: function(theme) {
                                return (0,_define_property/* default */.Z)({
                                    padding: 8
                                }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
                                    padding: 0
                                });
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                                sx: {
                                    height: "100%",
                                    width: "100%"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        maxWidth: 470
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default */.Z, {
                                        id: id,
                                        slug: slug,
                                        isFooter: false,
                                        styles: classes.formBds,
                                        isFullInput: true,
                                        placeholderColor: "#414141",
                                        bds: true,
                                        position: position,
                                        title: locale == "vi" ? "Để lại th\xf4ng tin nhận tư vấn đầu tư, t\xedch lũy BĐS" : "Leave information to receive investment advice, accumulate real estate"
                                    })
                                })
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                    sx: {
                        height: "100%",
                        padding: 8
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            maxWidth: 470
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default */.Z, {
                            id: id,
                            slug: slug,
                            isFooter: false,
                            styles: classes.form,
                            showIcon: false,
                            position: position
                        })
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var components_FormSupport = (FormSupport);


/***/ }),

/***/ 7093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./apis/queryFunctions/pageInfo.js
var pageInfo = __webpack_require__(1223);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./apis/fetch.js + 1 modules
var fetch = __webpack_require__(9900);
;// CONCATENATED MODULE: ./apis/queryFunctions/productType.js






var fetchProductType = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(options) {
        var itemProductType, _tmp, listProductType, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    itemProductType = (_tmp.ma_nhom = "Tất cả", _tmp.ten_nhom = "Tất cả", _tmp._id = "Tất cả", _tmp);
                    _tmp1 = {};
                    return [
                        4,
                        (0,fetch/* asyncGetList */.NE)((_tmp1.collection_name = "assproductgroup", _tmp1.options = {
                            limit: 100,
                            condition: options.condition
                        }, _tmp1))
                    ];
                case 1:
                    listProductType = _state.sent();
                    if (listProductType === null || listProductType === void 0 ? void 0 : listProductType.length) {
                        listProductType.unshift(itemProductType);
                    }
                    return [
                        2,
                        listProductType
                    ];
            }
        });
    });
    return function fetchProductType(options) {
        return _ref.apply(this, arguments);
    };
}();
var useFetchProductType = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return useQuery([
        "productType"
    ], function() {
        return fetchProductType(options);
    }, {
        staleTime: 3600000
    });
};
var fetchProducts = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var options, _tmp, _tmp1;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    options = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : _tmp;
                    if (options.condition.ma_nhom === "Tất cả") {
                        delete options.condition;
                    }
                    _tmp1 = {};
                    return [
                        4,
                        (0,fetch/* asyncGetList */.NE)((_tmp1.collection_name = "assproduct", _tmp1.options = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            limit: 9,
                            page: options.page
                        }, options), {
                            condition: options.condition,
                            sort: (0,_object_spread/* default */.Z)({}, (options === null || options === void 0 ? void 0 : options.sort) || {})
                        }), _tmp1))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function fetchProducts() {
        return _ref.apply(this, arguments);
    };
}();
var useFetchProducts = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    return useQuery([
        "products",
        (ref = options.condition) === null || ref === void 0 ? void 0 : ref.ma_nhom
    ], function() {
        return fetchProducts(options);
    });
};
var fetchRealEstateProducts = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(options) {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        (0,fetch/* asyncGetList */.NE)((_tmp.collection_name = "assproduct", _tmp.options = {
                            limit: 9,
                            page: (options === null || options === void 0 ? void 0 : options.page) || 1,
                            notfields: "vi_tri,thiet_ke,tien_nghi,mieu_ta,phap_ly",
                            condition: {
                                ma_loai: "Bất động sản"
                            }
                        }, _tmp))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function fetchRealEstateProducts(options) {
        return _ref.apply(this, arguments);
    };
}();
var useFetchRealEstateProducts = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    return useQuery([
        "products",
        {
            ma_loai: "Bất động sản",
            ma_nhom: (ref = options.condition) === null || ref === void 0 ? void 0 : ref.ma_nhom,
            options: options
        }, 
    ], function() {
        return fetchProducts(options);
    }, {
        staleTime: 3600000
    });
};
var fetchHighlightedProducts = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        (0,fetch/* asyncGetList */.NE)((_tmp.collection_name = "assproduct", _tmp.options = {
                            limit: 4
                        }, _tmp))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function fetchHighlightedProducts() {
        return _ref.apply(this, arguments);
    };
}();
var useFetchHighlightedProducts = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return useQuery([
        "products",
        "highlighted"
    ], function() {
        return fetchHighlightedProducts(options);
    }, {
        staleTime: 3600000
    });
};
var useFetchCountProduct = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    return useQuery([
        "countProduct",
        (ref = options.condition) === null || ref === void 0 ? void 0 : ref.ma_nhom
    ], function() {
        return fetchProducts(options);
    });
};

// EXTERNAL MODULE: ./apis/queryFunctions/projects.js + 1 modules
var projects = __webpack_require__(3354);
// EXTERNAL MODULE: ./apis/queryFunctions/subcribePosition.js
var subcribePosition = __webpack_require__(5381);
// EXTERNAL MODULE: ./common/components/BannerTextContent.js
var BannerTextContent = __webpack_require__(1425);
// EXTERNAL MODULE: ./common/components/Breadcrumbs.js + 1 modules
var Breadcrumbs = __webpack_require__(753);
// EXTERNAL MODULE: ./common/components/Button/BtnShowMore.js
var BtnShowMore = __webpack_require__(9235);
// EXTERNAL MODULE: ./common/components/DefaultSEO.js
var DefaultSEO = __webpack_require__(1623);
// EXTERNAL MODULE: ./common/components/FormSupport.js + 3 modules
var FormSupport = __webpack_require__(5603);
// EXTERNAL MODULE: ./common/components/Heading/SectionHeading.js
var SectionHeading = __webpack_require__(7217);
// EXTERNAL MODULE: ./common/components/HomeDownload.js
var HomeDownload = __webpack_require__(3617);
// EXTERNAL MODULE: ./common/components/InvestmentInfoCard.js
var InvestmentInfoCard = __webpack_require__(806);
// EXTERNAL MODULE: ./common/components/Line.js + 3 modules
var Line = __webpack_require__(8611);
// EXTERNAL MODULE: ./common/components/Video.js
var Video = __webpack_require__(2989);
// EXTERNAL MODULE: ./common/MainLayout/Container/index.js
var Container = __webpack_require__(7945);
// EXTERNAL MODULE: ./utils/getFieldFromFieldId.js
var getFieldFromFieldId = __webpack_require__(7662);
// EXTERNAL MODULE: ./utils/sanitizeDOMData.js + 1 modules
var sanitizeDOMData = __webpack_require__(2559);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Grid/Grid.js + 4 modules
var Grid = __webpack_require__(50);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Center/Center.js
var Center = __webpack_require__(9094);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./apis/queryFunctions/tracking.js
var tracking = __webpack_require__(7860);
// EXTERNAL MODULE: ./utils/appendImageUrlFromAPI.js + 1 modules
var appendImageUrlFromAPI = __webpack_require__(6646);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(6817);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(4761);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Card/Card.js + 4 modules
var Card = __webpack_require__(1017);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/AspectRatio/AspectRatio.js + 1 modules
var AspectRatio = __webpack_require__(4577);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/pack-sx/pack-sx.js
var pack_sx = __webpack_require__(7818);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/create-polymorphic-component/create-polymorphic-component.js
var create_polymorphic_component = __webpack_require__(8427);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/BackgroundImage/BackgroundImage.js





var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  radius: 0
};
const _BackgroundImage = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("BackgroundImage", defaultProps, props), { src, radius, sx } = _a, others = __objRest(_a, ["src", "radius", "sx"]);
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, __spreadProps(__spreadValues({}, others), {
    ref,
    sx: [
      (theme) => __spreadProps(__spreadValues({}, theme.fn.focusStyles()), {
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "block",
        width: "100%",
        border: 0,
        textDecoration: "none",
        color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
        backgroundImage: `url(${src})`,
        borderRadius: theme.fn.radius(radius)
      }),
      ...(0,pack_sx/* packSx */.R)(sx)
    ]
  }));
});
_BackgroundImage.displayName = "@mantine/core/BackgroundImage";
const BackgroundImage = (0,create_polymorphic_component/* createPolymorphicComponent */.F)(_BackgroundImage);


//# sourceMappingURL=BackgroundImage.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(5117);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Badge/Badge.js + 1 modules
var Badge = __webpack_require__(7789);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/List/List.js + 4 modules
var List = __webpack_require__(8949);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./public/icons/list-icon-straight-arrow-primary.svg
var list_icon_straight_arrow_primary = __webpack_require__(8029);
;// CONCATENATED MODULE: ./public/icons/star.png
/* harmony default export */ var star = ({"src":"/_next/static/media/star.3845af1a.png","height":30,"width":31,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJ1BMVEVMaXH////////////////////////////////////+/v7///////+hXjCTAAAADHRSTlMAu2b4TaDoGSuL1+DkGPFkAAAACXBIWXMAACE4AAAhOAFFljFgAAAAM0lEQVQImU3JOQ4AIAzEQCfhZv//XkREgauRDF/DHqoK0K1J0Sa4FNojj/KxwjQvvFOcAxxAAPIj1mtPAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./common/components/CardProduct.js









var useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    return {
        card: {
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
            marginRight: 31
        },
        title: {
            color: theme.colors.neutral[0],
            fontSize: 20,
            fontWeight: 600
        },
        footer: {
            padding: "".concat(theme.spacing.xs, "px ").concat(theme.spacing.lg, "px"),
            marginTop: theme.spacing.md,
            borderTop: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[2])
        },
        realEstates: {
            color: theme.colors.main[5],
            backgroundColor: theme.colors.neutral[0]
        },
        button: {
            height: 42,
            paddingLeft: 20,
            paddingRight: 20,
            borderRadius: 13,
            borderColor: "".concat(theme.colors.neutral[3]),
            borderWidth: 1,
            borderStyle: "solid",
            color: theme.colors.neutral[3],
            fontSize: 14,
            fontWeight: 600,
            "&:hover": {
                backgroundColor: theme.fn.darken(theme.colors.accent[2], 0.05),
                borderWidth: 0,
                color: theme.white
            }
        },
        paddingCard: {
            marginRight: 0
        },
        badge: (0,_define_property/* default */.Z)({
            flexDirection: "row",
            bottom: 10,
            left: 10,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            gap: 6,
            backgroundColor: theme.colors.accent[21],
            borderRadius: theme.radius.xs,
            // height: 25,
            padding: "2px 9px"
        }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
            padding: "0 7px",
            gap: 3
        }),
        comming: {
            flexDirection: "row",
            bottom: 10,
            right: 10,
            position: "absolute"
        }
    };
});
function CardProduct(param) {
    var data = param.data;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var classes = useStyles().classes;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var locale = (0,router.useRouter)().locale;
    var text_field = (data || {}).text_field;
    // const projectName =
    // 	getFieldFromFieldId("title", "content_id", text_field)?.label || "";
    var title = ((ref = (0,getFieldFromFieldId/* getFieldFromFieldId */.Z)("ten-nhom", "content_id", text_field)) === null || ref === void 0 ? void 0 : ref.label) || "";
    var projectName = ((ref1 = (0,getFieldFromFieldId/* getFieldFromFieldId */.Z)("title", "content_id", text_field)) === null || ref1 === void 0 ? void 0 : ref1.label) || "";
    var list = (0,getFieldFromFieldId/* getFieldFromFieldId */.Z)("list-item", "content_id", text_field);
    var isHot = (((ref2 = (0,getFieldFromFieldId/* getFieldFromFieldId */.Z)("hot", "content_id", text_field)) === null || ref2 === void 0 ? void 0 : ref2.label) || "false") === "true";
    var isRunning = (((ref3 = (0,getFieldFromFieldId/* getFieldFromFieldId */.Z)("running", "content_id", text_field)) === null || ref3 === void 0 ? void 0 : ref3.label) || "false") === "true";
    var label = {
        vi: {
            hot: "Dự \xe1n hot",
            comming: "Sắp ra mắt"
        },
        en: {
            hot: "Trending",
            comming: "Sắp ra mắt"
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* Card */.Z, {
        p: 0,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card.Section */.Z.Section, {
                mb: "sm",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AspectRatio/* AspectRatio */.o, {
                    ratio: 272 / 282,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BackgroundImage, {
                        src: (data === null || data === void 0 ? void 0 : data.picture_1) ? (0,appendImageUrlFromAPI/* default */.Z)({
                            src: (data === null || data === void 0 ? void 0 : data.picture_1) || (data === null || data === void 0 ? void 0 : data.picture_2) || (data === null || data === void 0 ? void 0 : data.picture_3)
                        }) : "https://via.placeholder.com/272x282",
                        alt: title,
                        radius: 13,
                        children: [
                            isHot && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                                className: classes.badge,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                        sx: function(theme) {
                                            return (0,_define_property/* default */.Z)({
                                                position: "relative",
                                                width: 16,
                                                height: 16
                                            }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
                                                width: 10,
                                                height: 10
                                            });
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: star,
                                            alt: "star icon",
                                            layout: "fill"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        size: 14,
                                        weight: 800,
                                        color: theme.white,
                                        sx: function(theme) {
                                            return (0,_define_property/* default */.Z)({
                                                fontSize: 14
                                            }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
                                                fontSize: 10
                                            });
                                        },
                                        children: label === null || label === void 0 ? void 0 : (ref4 = label[locale]) === null || ref4 === void 0 ? void 0 : ref4.hot
                                    })
                                ]
                            }),
                            !isRunning && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                className: classes.comming,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                    component: "span",
                                    ml: 8,
                                    sx: {
                                        color: "#ffffff",
                                        minHeight: 24
                                    },
                                    children: label === null || label === void 0 ? void 0 : (ref5 = label[locale]) === null || ref5 === void 0 ? void 0 : ref5.comming
                                })
                            })
                        ]
                    })
                })
            }),
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                lineClamp: 1,
                children: title
            }),
            ((data === null || data === void 0 ? void 0 : data.title) || projectName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                lineClamp: 3,
                size: 18,
                weight: 500,
                mt: 8,
                mb: 4,
                sx: {
                    minHeight: 56
                },
                children: (data === null || data === void 0 ? void 0 : data.title) || projectName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List */.a, {
                children: list && list.map(function(param, index) {
                    var label = param.label, content_editor = param.content_editor;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List.Item */.a.Item, {
                        mb: 2,
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                            sx: {
                                width: 14,
                                height: 14,
                                position: "relative",
                                marginTop: 6
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: list_icon_straight_arrow_primary/* default */.Z,
                                alt: "vector Top right",
                                // width={14}
                                // height={14}
                                layout: "fill"
                            })
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            size: "sm",
                            children: String(content_editor || label).charAt(0).toUpperCase() + String(content_editor || label).slice(1)
                        })
                    }, index);
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./utils/slugifyString.js
var slugifyString = __webpack_require__(1957);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/SimpleGrid/SimpleGrid.js + 1 modules
var SimpleGrid = __webpack_require__(9469);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Loader/Loader.js + 3 modules
var Loader = __webpack_require__(966);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Pagination/Pagination.js + 9 modules
var Pagination = __webpack_require__(7804);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./pages/san-pham/bat-dong-san/components/ProductItem.js
// import { useFetchPageInfo } from "@/apis/queryFunctions/pageInfo";











function ProductItem(param) {
    var listProduct = param.listProduct, isFetching = param.isFetching;
    var ref, ref1, ref2;
    var locale = (0,router.useRouter)().locale;
    var ref3 = (0,_sliced_to_array/* default */.Z)(react.useState(1), 2), page = ref3[0], setPage = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)(react.useState(9), 1), limit = ref4[0];
    var ref5 = (0,_sliced_to_array/* default */.Z)(react.useState(400), 2), height = ref5[0], setHeight = ref5[1];
    react.useEffect(function() {
        if (window.innerWidth < 768) {
            setHeight(600);
        }
    }, []);
    // const { data: projects } = useFetchPageInfo("web/home/product-hightlight", {
    // 	condition: { ngon_ngu: locale },
    // });
    // const { add_on_4 } = projects || {};
    var handleTracking = function(link) {
        switch(link){
            case "The Lake Farm Hồ Trị An":
                return (0,tracking/* addtrackingEvent */.sm)({
                    vi_tri: tracking/* TRACKING_VI_TRI.DU-AN */.QK["DU-AN"],
                    field_id: tracking/* TRACKING_NAMES.DU_AN_Duan_TLF */.BK.DU_AN_Duan_TLF
                });
            case "Zen Group Tower":
                return (0,tracking/* addtrackingEvent */.sm)({
                    vi_tri: tracking/* TRACKING_VI_TRI.DU-AN */.QK["DU-AN"],
                    field_id: tracking/* TRACKING_NAMES.DU_AN_Duan_Zentower */.BK.DU_AN_Duan_Zentower
                });
            case "Long Sơn Resort & Condotel B\xecnh Thuận":
                return (0,tracking/* addtrackingEvent */.sm)({
                    vi_tri: tracking/* TRACKING_VI_TRI.DU-AN */.QK["DU-AN"],
                    field_id: tracking/* TRACKING_NAMES.DU_AN_Duan_LSR */.BK.DU_AN_Duan_LSR
                });
            case "Nhị B\xecnh Farmstay":
                return (0,tracking/* addtrackingEvent */.sm)({
                    vi_tri: tracking/* TRACKING_VI_TRI.DU-AN */.QK["DU-AN"],
                    field_id: tracking/* TRACKING_NAMES.DU_AN_Duan_NBF */.BK.DU_AN_Duan_NBF
                });
            default:
                return (0,tracking/* addtrackingEvent */.sm)({
                    vi_tri: tracking/* TRACKING_VI_TRI.DU-AN */.QK["DU-AN"],
                    field_id: link || ""
                });
        }
    };
    var label = {
        vi: {
            notFound: "Chưa c\xf3 sản phẩm ở nh\xf3m n\xe0y"
        },
        en: {
            notFound: "There are no products in this group"
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid.Col */.r.Col, {
        xs: 12,
        lg: 9,
        children: [
            (listProduct === null || listProduct === void 0 ? void 0 : listProduct.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleGrid/* SimpleGrid */.M, {
                sx: {
                    gap: 30
                },
                cols: 3,
                breakpoints: [
                    {
                        maxWidth: 600,
                        cols: 2
                    },
                    {
                        maxWidth: 1000,
                        cols: 3
                    }, 
                ],
                children: (ref1 = (ref = listProduct === null || listProduct === void 0 ? void 0 : listProduct.sort(function(a, b) {
                    return +(a === null || a === void 0 ? void 0 : a.summary) - +(b === null || b === void 0 ? void 0 : b.summary);
                })) === null || ref === void 0 ? void 0 : ref.slice((page - 1) * limit, page * limit)) === null || ref1 === void 0 ? void 0 : ref1.map(function(item, index) {
                    var ref;
                    var ten_san_pham = ((ref = (0,getFieldFromFieldId/* getFieldFromFieldId */.Z)("title", "content_id", item === null || item === void 0 ? void 0 : item.text_field)) === null || ref === void 0 ? void 0 : ref.label) || "";
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/san-pham/bat-dong-san/".concat((0,slugifyString/* default */.Z)((item === null || item === void 0 ? void 0 : item.title) + " " + item.ma_trang)),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            onClick: function() {
                                return handleTracking(ten_san_pham);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardProduct, {
                                data: item
                            })
                        })
                    }, index);
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                style: {
                    minHeight: height - 200
                },
                children: isFetching ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    children: label === null || label === void 0 ? void 0 : (ref2 = label[locale]) === null || ref2 === void 0 ? void 0 : ref2.notFound
                })
            }),
            (listProduct === null || listProduct === void 0 ? void 0 : listProduct.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                sx: function(theme) {
                    return (0,_define_property/* default */.Z)({
                        display: "flex",
                        justifyContent: "flex-end"
                    }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
                        justifyContent: "center"
                    });
                },
                mt: 40,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* Pagination */.t, {
                    total: Math.ceil((listProduct === null || listProduct === void 0 ? void 0 : listProduct.length) / limit),
                    onChange: setPage
                })
            })
        ]
    });
}
/* harmony default export */ var components_ProductItem = (ProductItem);

// EXTERNAL MODULE: ./common/components/HomeTitle.js
var HomeTitle = __webpack_require__(9936);
;// CONCATENATED MODULE: ./pages/san-pham/bat-dong-san/components/ProductTitle.js





var ProductTitle_useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    return {
        titleHighLight: {
            color: theme.colors.main[1],
            fontWeight: 600
        }
    };
});
function ProductTitle() {
    var ref;
    var locale = (0,router.useRouter)().locale;
    var classes = ProductTitle_useStyles().classes;
    var label = {
        vi: {
            title: "Danh s\xe1ch c\xe1c bất động sản đầu tư c\xf9ng "
        },
        en: {
            title: "List of properties to invest with "
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        component: "section",
        py: 12,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* default */.Z, {
                index: 2
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomeTitle/* default */.Z, {
                align: "center",
                children: [
                    label === null || label === void 0 ? void 0 : (ref = label[locale]) === null || ref === void 0 ? void 0 : ref.title,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: classes.titleHighLight,
                        children: "ZenOne"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var components_ProductTitle = (ProductTitle);

;// CONCATENATED MODULE: ./public/icons/filter-type.png
/* harmony default export */ var filter_type = ({"src":"/_next/static/media/filter-type.e22fab08.png","height":39,"width":39,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJFBMVEWm7uqo7us0e3WK2tSn7uqn7uuo7+uu9PF1z8hJq6JkvLVTm5V7Do/2AAAABnRSTlP+iv7+Yq2cJz71AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAM0lEQVQImR2LAQoAIAwCr1a66v//jU04kEPZSBIDJKDwnfN1iXNSJZ3XVBzpHrWGof6tDyLQAOkcxhfNAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/UnstyledButton/UnstyledButton.js + 1 modules
var UnstyledButton = __webpack_require__(4736);
;// CONCATENATED MODULE: ./pages/san-pham/bat-dong-san/components/ProductType.js








var ProductType_useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    return {
        boxType: {
            borderColor: theme.colors.main,
            borderWidth: 1,
            borderStyle: "solid",
            borderRadius: 16,
            padding: 18,
            height: "fit-content"
        },
        flexRow: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 10
        },
        titleProductType: {
            borderColor: theme.colors.neutral[3],
            borderWidth: 1,
            borderStyle: "solid",
            borderRadius: theme.radius.xs,
            padding: 5,
            color: theme.colors.neutral[2],
            fontSize: 16,
            fontWeight: 500
        },
        activeProductTitleProductType: {
            borderColor: theme.colors.neutral[3],
            color: theme.colors.main,
            backgroundColor: theme.colors.neutral[0]
        },
        buttonFilter: {
            borderColor: theme.colors.neutral[3],
            borderWidth: 1,
            borderStyle: "solid",
            borderRadius: theme.radius.xs,
            color: theme.colors.neutral[2],
            fontSize: 16,
            fontWeight: 500,
            width: "100%",
            backgroundColor: theme.colors.neutral[0],
            "&:hover": {
                backgroundColor: theme.colors.main[5]
            }
        },
        titleButton: {
            color: theme.colors.main[5],
            fontSize: 16,
            fontWeight: 500,
            textAlign: "center",
            width: "100%",
            padding: 5,
            "&:hover": {
                color: theme.colors.neutral[0]
            }
        }
    };
});
function ProductType(param) {
    var listProductType = param.listProductType, active = param.active, setActive = param.setActive, setActiveWithButon = param.setActiveWithButon;
    var ref, ref1, ref2;
    // console.log("active", active);
    var ref3 = ProductType_useStyles(), classes = ref3.classes, cx = ref3.cx;
    var locale = (0,router.useRouter)().locale;
    var label = {
        vi: {
            title: "Bộ lọc",
            btn: "T\xecm kiếm"
        },
        en: {
            title: "Filter",
            btn: "Search"
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
        xs: 12,
        lg: 3,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
            className: classes.boxType,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                    className: classes.flexRow,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: filter_type,
                            alt: "ProductTypeIcon"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            children: label === null || label === void 0 ? void 0 : (ref = label[locale]) === null || ref === void 0 ? void 0 : ref.title
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid */.r, {
                    grow: true,
                    sx: {
                        gap: 10
                    },
                    m: 0,
                    my: 10,
                    children: (ref1 = listProductType === null || listProductType === void 0 ? void 0 : listProductType.filter(function(item) {
                        return (item === null || item === void 0 ? void 0 : item.ma_loai) !== "Cổ phần";
                    })) === null || ref1 === void 0 ? void 0 : ref1.map(function(item, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(UnstyledButton/* UnstyledButton */.k, {
                            className: cx(classes.titleProductType, (0,_define_property/* default */.Z)({}, classes.activeProductTitleProductType, (active === null || active === void 0 ? void 0 : active.indexOf(item === null || item === void 0 ? void 0 : item.label)) >= 0)),
                            onClick: function() {
                                return setActive(function(prev) {
                                    return (prev === null || prev === void 0 ? void 0 : prev.indexOf("Tất cả")) >= 0 ? (item === null || item === void 0 ? void 0 : item.label) === "Tất cả" ? (0,_to_consumable_array/* default */.Z)(prev) : [
                                        item === null || item === void 0 ? void 0 : item.label
                                    ] : (item === null || item === void 0 ? void 0 : item.label) === "Tất cả" ? [
                                        item === null || item === void 0 ? void 0 : item.label
                                    ] : (prev === null || prev === void 0 ? void 0 : prev.indexOf(item === null || item === void 0 ? void 0 : item.label)) >= 0 ? (prev === null || prev === void 0 ? void 0 : prev.length) <= 1 ? (0,_to_consumable_array/* default */.Z)(prev) : (0,_to_consumable_array/* default */.Z)((prev === null || prev === void 0 ? void 0 : prev.filter(function(el) {
                                        return el !== (item === null || item === void 0 ? void 0 : item.label);
                                    })) || []) : (0,_to_consumable_array/* default */.Z)(prev).concat([
                                        item === null || item === void 0 ? void 0 : item.label
                                    ]);
                                });
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                children: item.content
                            })
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UnstyledButton/* UnstyledButton */.k, {
                    className: classes.buttonFilter,
                    onClick: function() {
                        return setActiveWithButon((active === null || active === void 0 ? void 0 : active.indexOf("Tất cả")) >= 0 ? listProductType === null || listProductType === void 0 ? void 0 : listProductType.reduce(function(arr, curr) {
                            arr.push(curr === null || curr === void 0 ? void 0 : curr.label);
                            return arr;
                        // eslint-disable-next-line no-mixed-spaces-and-tabs
                        }, []) : active);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        className: classes.titleButton,
                        children: label === null || label === void 0 ? void 0 : (ref2 = label[locale]) === null || ref2 === void 0 ? void 0 : ref2.btn
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var components_ProductType = (ProductType);

;// CONCATENATED MODULE: ./pages/san-pham/bat-dong-san/index.page.js






















// import { dehydrate, QueryClient } from "@tanstack/react-query";





function BatDongSan() {
    var ref, ref1, ref2, ref3;
    var ref4 = (0,router.useRouter)(), locale = ref4.locale, asPath = ref4.asPath;
    var ref5 = (0,_sliced_to_array/* default */.Z)(react.useState([]), 2), listProduct = ref5[0], setListProduct = ref5[1];
    var ref6 = (0,pageInfo/* useFetchPageInfo */.u$)("web/san-pham/bat-dong-san", {
        condition: {
            ngon_ngu: locale
        }
    }), pageContent = ref6.data;
    // const { data: projectsContent, isFetching } = useFetchPageInfo(
    // 	"web/home/product-hightlight",
    // 	{
    // 		condition: { ngon_ngu: locale },
    // 	}
    // );
    var ref7 = (0,projects/* useFetchProjectList */.JJ)({
        limit: 999,
        condition: {
            ma_loai_tin_tuc: "du-an-bat-dong-san",
            ngon_ngu: locale
        },
        sort: {
            summary: 1
        }
    }), projectList = ref7.data;
    var listProductType = ((ref = (0,getFieldFromFieldId/* getFieldFromFieldId */.Z)("ma-loai", "id", pageContent === null || pageContent === void 0 ? void 0 : pageContent.add_on_5)) === null || ref === void 0 ? void 0 : ref.text_field) || [];
    var ref8 = (0,react.useState)([]), active = ref8[0], setActive = ref8[1];
    var ref9 = (0,react.useState)([]), activeWithButon = ref9[0], setActiveWithButon = ref9[1];
    var bannerPlaceholder = (0,getFieldFromFieldId/* getFieldFromFieldId */.Z)("banner-placeholder", "picture_id", pageContent === null || pageContent === void 0 ? void 0 : pageContent.pictures);
    var SectionHeading2 = (0,getFieldFromFieldId/* getFieldFromFieldId */.Z)("section-2-title", "content_id", pageContent === null || pageContent === void 0 ? void 0 : pageContent.text_field);
    var investmentTypes = (pageContent === null || pageContent === void 0 ? void 0 : pageContent.add_on_4) || [];
    // const { data: listProductType, isFetching } = useFetchProductType({
    // 	condition: {
    // 		ma_loai: "Bất động sản",
    // 	},
    // });
    // const { data: listProduct, isFetching: isFetchingProduct } =
    // 	useFetchRealEstateProducts({
    // 		page: 1,
    // 		condition: {
    // 			ma_nhom: { $in: activeWithButon || [] },
    // 			ma_loai: "Bất động sản",
    // 		},
    // 		sort: {
    // 			stt: 1,
    // 		},
    // 	});
    // console.log("projects", projects);
    var label = {
        vi: {
            breadcrumbs: [
                {
                    title: "Trang chủ",
                    href: "/"
                },
                {
                    title: "Sản phẩm",
                    href: "#"
                },
                {
                    title: "Bất động sản",
                    href: "/san-pham/bat-dong-san"
                }, 
            ]
        },
        en: {
            breadcrumbs: [
                {
                    title: "Home",
                    href: "/"
                },
                {
                    title: "Products",
                    href: "#"
                },
                {
                    title: "Real estate",
                    href: "/san-pham/bat-dong-san"
                }, 
            ]
        }
    };
    (0,react.useEffect)(function() {
        if ((listProductType === null || listProductType === void 0 ? void 0 : listProductType.length) && !(active === null || active === void 0 ? void 0 : active.length)) {
            var ref, ref1, ref2;
            setActive([
                (ref = listProductType[0]) === null || ref === void 0 ? void 0 : ref.label
            ]);
            setActiveWithButon(((ref1 = listProductType[0]) === null || ref1 === void 0 ? void 0 : ref1.label) === "Tất cả" ? listProductType === null || listProductType === void 0 ? void 0 : listProductType.reduce(function(arr, curr) {
                arr.push(curr === null || curr === void 0 ? void 0 : curr.label);
                return arr;
            // eslint-disable-next-line no-mixed-spaces-and-tabs
            }, []) : (0,_to_consumable_array/* default */.Z)(((ref2 = listProductType[0]) === null || ref2 === void 0 ? void 0 : ref2.label) || []));
        }
    }, [
        listProductType
    ]);
    (0,react.useEffect)(function() {
        if ((activeWithButon === null || activeWithButon === void 0 ? void 0 : activeWithButon.length) && (projectList === null || projectList === void 0 ? void 0 : projectList.length)) {
            // console.log(
            // 	projects?.filter((el) => {
            // 		const category =
            // 			getFieldFromFieldId("category", "content_id", el?.text_field)
            // 				?.label || "";
            // 		const tenNhom =
            // 			getFieldFromFieldId("ten-nhom", "content_id", el?.text_field)
            // 				?.label || "";
            // 		return (
            // 			category === "Bất động sản" && activeWithButon?.includes(tenNhom)
            // 		);
            // 	})
            // );
            setListProduct(projectList === null || projectList === void 0 ? void 0 : projectList.filter(function(el) {
                // const category =
                // 	getFieldFromFieldId("category", "content_id", el?.text_field)
                // 		?.label || "";
                // const tenNhom =
                // 	getFieldFromFieldId("ten-nhom", "content_id", el?.text_field)
                // 		?.label || "";
                return (el === null || el === void 0 ? void 0 : el.text_1) === "Bất động sản" && (activeWithButon === null || activeWithButon === void 0 ? void 0 : activeWithButon.includes(el === null || el === void 0 ? void 0 : el.text_2));
            }));
        }
    }, [
        activeWithButon,
        projectList
    ]);
    var seo = {
        title: pageContent === null || pageContent === void 0 ? void 0 : pageContent.seo_title,
        description: pageContent === null || pageContent === void 0 ? void 0 : pageContent.seo_description,
        picture1: pageContent === null || pageContent === void 0 ? void 0 : pageContent.seo_image_1,
        picture2: pageContent === null || pageContent === void 0 ? void 0 : pageContent.seo_image_2,
        url: asPath
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.ZP, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultSEO/* default */.Z, {
                seo: seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                pt: 24,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                    items: label === null || label === void 0 ? void 0 : (ref1 = label[locale]) === null || ref1 === void 0 ? void 0 : ref1.breadcrumbs,
                    isLoading: false
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                component: "section",
                py: 16,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid */.r, {
                    gutter: "xl",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                            xs: 12,
                            md: 6,
                            sx: {
                                display: "flex",
                                alignItems: "center"
                            },
                            order: 2,
                            orderMd: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerTextContent/* default */.Z, {
                                data: (pageContent === null || pageContent === void 0 ? void 0 : pageContent.text_field) || []
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                            xs: 12,
                            md: 6,
                            order: 1,
                            orderMd: 2,
                            justify: "center",
                            align: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                sx: {
                                    aspectRatio: "0.9",
                                    position: "relative",
                                    maxWidth: 425
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Video/* default */.Z, {
                                    video_url: pageContent === null || pageContent === void 0 ? void 0 : pageContent.video_url,
                                    placeholderImageUrl: bannerPlaceholder === null || bannerPlaceholder === void 0 ? void 0 : bannerPlaceholder.picture_url
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSupport/* default */.Z, {
                position: subcribePosition/* SUB_POSITION.BDS */.X.BDS,
                bds: true,
                list: listProduct
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* default */.Z, {
                index: 0
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                component: "section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeading/* default */.Z, {
                        children: (0,sanitizeDOMData/* default */.Z)((SectionHeading2 === null || SectionHeading2 === void 0 ? void 0 : SectionHeading2.content_editor) || (SectionHeading2 === null || SectionHeading2 === void 0 ? void 0 : SectionHeading2.content))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid */.r, {
                        gutter: "xl",
                        children: (ref3 = (ref2 = investmentTypes === null || investmentTypes === void 0 ? void 0 : investmentTypes.filter(function(el) {
                            return el === null || el === void 0 ? void 0 : el.shared;
                        })) === null || ref2 === void 0 ? void 0 : ref2.sort(function(a, b) {
                            return +(a === null || a === void 0 ? void 0 : a.stt) - +(b === null || b === void 0 ? void 0 : b.stt);
                        })) === null || ref3 === void 0 ? void 0 : ref3.map(function(type, i) {
                            var ref, ref1, ref2, ref3;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                span: 12,
                                md: 6,
                                lg: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InvestmentInfoCard/* default */.Z, {
                                    title: (ref1 = type === null || type === void 0 ? void 0 : (ref = type.text_field) === null || ref === void 0 ? void 0 : ref.find(function(el) {
                                        return (el === null || el === void 0 ? void 0 : el.content_id) === "title";
                                    })) === null || ref1 === void 0 ? void 0 : ref1.content,
                                    iconUrl: type === null || type === void 0 ? void 0 : (ref2 = type.pictures) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.picture_url,
                                    list: type === null || type === void 0 ? void 0 : type.text_field
                                })
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                        sx: function(theme) {
                            return (0,_define_property/* default */.Z)({
                                marginTop: 38
                            }, "@media max-width(".concat(theme.breakpoints.md, "px)"), {
                                marginTop: 10
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BtnShowMore/* default */.Z, {
                            href: "/chinh-sach-dau-tu-hop-tac?keyword=chinh-sach-dau-tu-bat-dong-san"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProductTitle, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid */.r, {
                cols: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProductType, {
                        listProductType: listProductType,
                        // isFetching={isFetching}
                        active: active,
                        setActive: setActive,
                        setActiveWithButon: setActiveWithButon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProductItem, {
                        listProduct: listProduct
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeDownload/* default */.Z, {})
        ]
    });
}
/* harmony default export */ var index_page = (BatDongSan);


/***/ }),

/***/ 1957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ slugify; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7535);

function convert_vi_to_en(str) {
    if (!(typeof str === "string" || (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(str, String))) return "";
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
    str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
    str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
    str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
    str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
    str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
    str = str.replace(/Đ/g, "D");
    str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
    str = str.replace(/  +/g, " ");
    return str;
}
function slugify(string) {
    var denicodeString = convert_vi_to_en(string);
    return denicodeString.toString().normalize("NFKD").toLowerCase().trim().replace(/\s+/g, "-").replace(/[^\w\-]+/g, "").replace(/\-\-+/g, "-");
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [994,364,419,774,888,179], function() { return __webpack_exec__(977); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);